export default "__VITE_ASSET__Di35BWUA__"